module.exports = __webpack_public_path__ + "img/apptu3.85b6ef97.png";